import { useLocation } from 'react-router-dom';
import { useScrollToTopOnChange } from '../hooks/useScrollToTopOnChange';

/**
 * HashRouter keeps the document scroll when `?rz=` / path changes.
 * Reset on every route so report / dashboard / back all start at the top.
 */
export default function ScrollToTopOnNavigation() {
  const { pathname, search } = useLocation();
  useScrollToTopOnChange(`${pathname}${search}`);
  return null;
}
